// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-spacing1[data-v-32f0bbe6]{padding-bottom:1rem}.small-spacing2[data-v-32f0bbe6]{padding-bottom:1.5rem}", ""]);
// Exports
module.exports = exports;
